import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import Service from './service';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const INITIALIZED = 'INITIALIZED';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const ADD_DUMMY_PLEDGE = 'ADD_DUMMY_PLEDGE';
export const UPDATE_PLEDGE = 'UPDATE_PLEDGE';
export const REMOVE_PLEDGE = 'REMOVE_PLEDGE';

export const ADD_DUMMY_ENTITY = 'ADD_DUMMY_ENTITY';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';
export const REMOVE_ENTITY = 'REMOVE_ENTITY';

export const UPDATE_PROPERTY_MARKET = 'UPDATE_PROPERTY_MARKET';
export const RESET_PROPERTY_MARKET = 'RESET_PROPERTY_MARKET';

export const ADD_DUMMY_OWNER = 'ADD_DUMMY_OWNER';
export const UPDATE_OWNER = 'UPDATE_OWNER';
export const REMOVE_OWNER = 'REMOVE_OWNER';

export const UPDATE_SEARCHING_DIRECCION = 'UPDATE_SEARCHING_DIRECCION';
export const UPDATE_SEARCHING_POBLACION = 'UPDATE_SEARCHING_POBLACION';
export const UPDATE_SEARCHING_APPRAISER = 'UPDATE_SEARCHING_APPRAISER';
export const UPDATE_SEARCHED_APPRAISER = 'UPDATE_SEARCHED_APPRAISER';
export const UPDATE_SEARCHED_APPRAISER_NAME = 'UPDATE_SEARCHED_APPRAISER_NAME';
export const UPDATE_LOADING_PLEDGE = 'UPDATE_LOADING_PLEDGE';
export const UPDATE_LOADING_OWNER = 'UPDATE_LOADING_OWNER';
export const UPDATE_LOADING_BURDEN = 'UPDATE_LOADING_BURDEN';
export const UPDATE_LOADING_APPRAISAL = 'UPDATE_LOADING_APPRAISAL';
export const UPDATE_LOADING_PROPERTY_MARKET = 'UPDATE_LOADING_PROPERTY_MARKET';
export const UPDATE_LOADING_MARKET_RESEARCH = 'UPDATE_LOADING_MARKET_RESEARCH';
export const REPLACE_APPRAISER = 'REPLACE_APPRAISER';
export const UPDATE_SEARCHING_APPRAISER_FLAG = 'UPDATE_SEARCHING_APPRAISER_FLAG';
/* ACTIONS */
export const clearModuleAction = 'clearModuleAction';
export const initModuleAction = 'initModuleAction';
export const initPledgeAction = 'initPledgeAction';

export const updatePledgeAction = 'updatePledgeAction';
export const removePledgeAction = 'removePledgeAction';
export const addPledgeAction = 'addPledgeAction';

export const updateOwnerAction = 'updateOwnerAction';
export const removeOwnerAction = 'removeOwnerAction';
export const addOwnerAction = 'addOwnerAction';

export const updateBurdenAction = 'updateBurdenAction';
export const removeBurdenAction = 'removeBurdenAction';
export const addBurdenAction = 'addBurdenAction';

export const updateAppraisalAction = 'updateAppraisalAction';
export const removeAppraisalAction = 'removeAppraisalAction';
export const addAppraisalAction = 'addAppraisalAction';

export const updateMarketResearchAction = 'updateMarketResearchAction';
export const removeMarketResearchAction = 'removeMarketResearchAction';
export const addMarketResearchAction = 'addMarketResearchAction';
export const addPdfToMarketResearchAction = 'addPdfToMarketResearchAction';

export const updatePropertyMarketAction = 'updatePropertyMarketAction';
export const removePropertyMarketAction = 'removePropertyMarketAction';

export const updateOperationAction = 'updateOperationAction';

// export const searchDireccionAction = 'searchDireccionAction';
// export const searchPoblacionAction = 'searchDireccionAction';
export const searchAppraiserAction = 'searchAppraiserAction';
export const replaceAppraiserAction = 'replaceAppraiserAction';
/* GETTERS */
export const searchingDireccionStateGetter = 'searchingDireccion';
export const searchingPoblacionStateGetter = 'searchingPoblacion';

export const pledgesGetter = 'pledges';
export const pledgeGetter = 'pledge';
export const existDummyGetter = 'existDummy';

export const pledgeOwnersGetter = 'pledgeOwners';
export const pledgeOwnersDataGetter = 'pledgeOwnersData';
export const getOwnerGetter = 'getOwner';
export const canAddOwnerGetter = 'canAddOwner';
export const canRemoveOwnerGetter = 'canRemoveOwner';
export const loadingOwnerGetter = 'loadingOwner';

export const pledgeBurdensGetter = 'pledgeBurdens';
export const pledgeBurdensDataGetter = 'pledgeBurdensData';
export const getBurdenGetter = 'getBurden';
export const canAddBurdenGetter = 'canAddBurden';
export const canRemoveBurdenGetter = 'canRemoveBurden';
export const loadingBurdenGetter = 'loadingBurden';

export const pledgeAppraisalsGetter = 'pledgeAppraisals';
export const pledgeAppraisalsDataGetter = 'pledgeAppraisalsData';
export const getAppraisalGetter = 'getAppraisal';
export const canAddAppraisalGetter = 'canAddAppraisal';
export const canRemoveAppraisalGetter = 'canRemoveAppraisal';

export const propertyMarketResearchsGetter = 'propertyMarketResearchs';
export const searchingAppraiserGetter = 'searchingAppraiser';
export const loadingAppraisalGetter = 'loadingAppraisal';
export const searchedAppraisersGetter = 'searchedAppraisers';

export default {
  namespaced: true,
  state: {
    initialized: false,
    operation: null,
    pledges: [],
    pledgesData: {},
    loadingPledge: [],
    owners: {},
    ownersData: {},
    loadingOwner: {},
    burdens: {},
    burdensData: {},
    loadingBurden: {},
    appraisals: {},
    appraisalsData: {},
    loadingAppraisal: {},
    propertyMarketData: {},
    loadingPropertyMarket: [],
    marketResearchs: {},
    marketResearchsData: {},
    pdfs: {},
    pdfsData: {},
    loadingMarketResearch: {},
    searchingDireccion: [],
    searchingPoblacion: [],
    searchingAppraiser: {},
    searchedAppraisers: [],
    searchedAppraiserByName: [],
    searchingAppraiserFlag: false,
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'initialized', false);
      Vue.set(state, 'operation', null);
      Vue.set(state, 'pledges', []);
      Vue.set(state, 'pledgesData', {});
      Vue.set(state, 'loadingPledge', []);
      Vue.set(state, 'owners', {});
      Vue.set(state, 'ownersData', {});
      Vue.set(state, 'loadingOwner', {});
      Vue.set(state, 'burdens', {});
      Vue.set(state, 'burdensData', {});
      Vue.set(state, 'loadingBurden', {});
      Vue.set(state, 'appraisals', {});
      Vue.set(state, 'appraisalsData', {});
      Vue.set(state, 'loadingAppraisal', {});
      Vue.set(state, 'propertyMarketData', {});
      Vue.set(state, 'loadingPropertyMarket', []);
      Vue.set(state, 'marketResearchs', {});
      Vue.set(state, 'marketResearchsData', {});
      Vue.set(state, 'pdfs', {});
      Vue.set(state, 'pdfsData', {});
      Vue.set(state, 'loadingMarketResearch', {});
      Vue.set(state, 'searchingDireccion', []);
      Vue.set(state, 'searchingPoblacion', []);
      Vue.set(state, 'searchingAppraiser', {});
      Vue.set(state, 'searchedAppraisers', []);
      Vue.set(state, 'searchedAppraiserByName', []);
      Vue.set(state, 'searchingAppraiserFlag', false);
    },
    [UPDATE_OPERATION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
    [INITIALIZED](state, payload) {
      Vue.set(state, 'initialized', payload);
    },
    [ADD_DUMMY_PLEDGE](state) {
      if (state.pledges.indexOf('dummy') < 0) {
        state.pledges.unshift('dummy');
        Vue.set(state.pledgesData, 'dummy', { id: 'dummy' });
        state.loadingPledge.push('');
        Vue.set(state.owners, 'dummy', ['dummy']);
        Vue.set(state.ownersData, 'dummy', { id: 'dummy' });
        Vue.set(state.loadingOwner, 'dummy', ['']);
        Vue.set(state.burdens, 'dummy', ['dummy']);
        Vue.set(state.burdensData, 'dummy', { id: 'dummy' });
        Vue.set(state.loadingBurden, 'dummy', ['']);
        Vue.set(state.appraisals, 'dummy', ['dummy']);
        Vue.set(state.appraisalsData, 'dummy', { id: 'dummy' });
        Vue.set(state.loadingAppraisal, 'dummy', ['']);
        Vue.set(state.propertyMarketData, 'dummy', { id: 'dummy' });
        state.loadingPropertyMarket.push('');
        Vue.set(state.marketResearchs, 'dummy', ['dummy']);
        Vue.set(state.marketResearchsData, 'dummy', { id: 'dummy' });
        Vue.set(state.loadingMarketResearch, 'dummy', ['']);
      }
    },
    [UPDATE_PLEDGE](state, payload) {
      const { pledge, index } = payload;
      if (index > -1) {
        Vue.set(state.pledges, index, pledge.id);
        Vue.set(state.pledgesData, state.pledges[index], pledge);
      }
    },
    [REMOVE_PLEDGE](state, payload) {
      const { pledge } = payload;
      const index = state.pledges.indexOf(pledge.id);
      if ('id' in pledge && index > -1) {
        state.pledges.splice(index, 1);
        state.loadingPledge.splice(index, 1);
        Vue.delete(state.pledgesData, pledge.id);
      }
    },
    [ADD_DUMMY_OWNER](state, payload) {
      const { pledge } = payload;
      if (pledge.id in state.owners && state.owners[pledge.id].indexOf('dummy') < 0) {
        state.owners[pledge.id].push('dummy');
        if (!('dummy' in state.ownersData)) {
          state.ownersData.dummy = { id: 'dummy' };
        }
      }
    },
    [UPDATE_OWNER](state, payload) {
      const { pledge, owner, index } = payload;
      if (pledge.id in state.owners && index > -1 &&
        state.owners[pledge.id].length > index) {
        state.owners[pledge.id].splice(index, 1, owner.id);
        Vue.set(state.ownersData, owner.id, owner);
      }
    },
    [REMOVE_OWNER](state, payload) {
      const { pledge, owner } = payload;
      if (pledge.id in state.owners) {
        const index = state.owners[pledge.id].indexOf(owner.id);
        if (index > -1) {
          state.owners[pledge.id].splice(index, 1);
          let found = false;
          Object.keys(state.owners).forEach((key) => {
            found = found || state.owners[key].indexOf(owner.id) > -1;
          });
          if (!found) {
            Vue.delete(state.ownersData, owner.id);
          }
        }
      }
    },
    [ADD_DUMMY_ENTITY](state, payload) {
      const { pledge, entity } = payload;
      const entityName = `${entity}s`;
      const entityData = `${entityName}Data`;
      if (!state[entityName][pledge.id]) {
        state[entityName][pledge.id] = [];
      }
      if (pledge.id in state[entityName] && state[entityName][pledge.id].indexOf('dummy') < 0) {
        state[entityName][pledge.id].push('dummy');
        state[entityName][pledge.id] = state[entityName][pledge.id].map(e => e);
        if (!('dummy' in state[entityData])) {
          state[entityData].dummy = { id: 'dummy' };
        }
        state.pledges = state.pledges.map(p => p);
      }
    },
    [UPDATE_ENTITY](state, payload) {
      const { pledge, entity, index, entityName } = payload;
      const entityNames = `${entityName}s`;
      const entityData = `${entityNames}Data`;
     /* if (pledge.id in state[entityNames] && index > -1) {
        state[entityNames][pledge.id].splice(index, 1, entity.id);
        Vue.set(state[entityData], entity.id, entity);
        state.pledges = state.pledges.map(p => p);
      } */
      if (state[entityNames] && !state[entityNames][pledge.id]) {
        Vue.set(state[entityNames], pledge.id, []);
      }
      Vue.set(state[entityNames][pledge.id], index, entity.id);
      // state[entityName][pledge.id].push(entity.id);
      Vue.set(state[entityData], entity.id, entity);
    },
    [REMOVE_ENTITY](state, payload) {
      const { pledge, entity, entityName } = payload;
      const entityNames = `${entityName}s`;
      const entityData = `${entityNames}Data`;
      if (pledge.id in state[entityNames]) {
        const index = state[entityNames][pledge.id].indexOf(entity.id);
        if (index > -1) {
          state[entityNames][pledge.id].splice(index, 1);
          let found = false;
          Object.keys(state[entityNames]).forEach((key) => {
            found = found || state[entityNames][key].indexOf(entity.id) > -1;
          });
          if (!found) {
            Vue.delete(state[entityData], entity.id);
          }
          Vue.set(state, 'pledges', state.pledges);
         // state.pledges = state.pledges.map(p => p);
        }
      }
    },
    [UPDATE_PROPERTY_MARKET](state, payload) {
      const { pledge, propertyMarket } = payload;
      Vue.set(state.propertyMarketData, pledge.id, propertyMarket);
    },
    [RESET_PROPERTY_MARKET](state, payload) {
      const { pledge } = payload;
      Vue.set(state.propertyMarketData, pledge.id, { id: 'dummy' });
    },
    [UPDATE_SEARCHING_DIRECCION](state, payload) {
      const { index, value } = payload;
      state.searchingDireccion.splice(index, 1, value);
    },
    [UPDATE_SEARCHING_POBLACION](state, payload) {
      const { index, value } = payload;
      state.searchingPoblacion.splice(index, 1, value);
    },
    [UPDATE_SEARCHING_APPRAISER](state, payload) {
      const { pledge, index, value } = payload;
      state.searchedAppraisers[pledge.id].splice(index, 1, value);
      // state.searchingAppraiser = payload;
    },
    [UPDATE_SEARCHED_APPRAISER_NAME](state, payload) {
      state.searchedAppraiserByName = payload;
    },
    [UPDATE_SEARCHED_APPRAISER](state, payload) {
      state.searchedAppraisers = payload;
    },
    [UPDATE_LOADING_PLEDGE](state, payload) {
      const { index, value } = payload;
      if (value) {
        state.loadingPledge.splice(index, 1, value);
      } else {
        state.loadingPledge.splice(index, 1);
      }
    },
    [UPDATE_LOADING_OWNER](state, payload) {
      const { pledge, index, value } = payload;
      if (!state.loadingOwner[pledge.id]) {
        state.loadingOwner[pledge.id] = [];
      }
      if (value) {
        state.loadingOwner[pledge.id].splice(index, 1, value);
      } else {
        state.loadingOwner[pledge.id].splice(index, 1);
      }
    },
    [UPDATE_LOADING_BURDEN](state, payload) {
      const { pledge, index, value } = payload;
      if (!state.loadingBurden[pledge.id]) {
        state.loadingBurden[pledge.id] = [];
      }
      if (value) {
        state.loadingBurden[pledge.id].splice(index, 1, value);
      } else {
        state.loadingBurden[pledge.id].splice(index, 1);
      }
    },
    [UPDATE_LOADING_APPRAISAL](state, payload) {
      const { pledge, index, value } = payload;
      if (!state.loadingAppraisal[pledge.id]) {
        state.loadingAppraisal[pledge.id] = [];
      }
      if (value) {
        state.loadingAppraisal[pledge.id].splice(index, 1, value);
      } else {
        state.loadingAppraisal[pledge.id].splice(index, 1);
      }
    },
    [UPDATE_LOADING_PROPERTY_MARKET](state, payload) {
      const { pledge, value } = payload;
      if (!state.loadingAppraisal[state.pledges.indexOf(pledge.id)]) {
        state.loadingAppraisal[state.pledges.indexOf(pledge.id)] = '';
      }
      if (value) {
        state.loadingPropertyMarket[state.pledges.indexOf(pledge.id)] = value;
      } else {
        state.loadingPropertyMarket.splice(state.pledges.indexOf(pledge.id), 1);
      }
    },
    [UPDATE_LOADING_MARKET_RESEARCH](state, payload) {
      const { propertyMarket, index, value } = payload;
      if (!state.loadingMarketResearch[propertyMarket.id]) {
        state.loadingMarketResearch[propertyMarket.id] = [];
      }
      if (value) {
        state.loadingMarketResearch[propertyMarket.id].splice(index, 1, value);
      } else {
        state.loadingMarketResearch[propertyMarket.id].splice(index, 1);
      }
    },
    [REPLACE_APPRAISER](state, payload) {
      const { appraiser, index, pledge } = payload;

      state.appraisalsData[state.appraisals[pledge.id][index]] = appraiser;
    },
    [UPDATE_SEARCHING_APPRAISER_FLAG](state, payload) {
      Vue.set(state, 'searchingAppraiserFlag', payload);
    },
  },
  actions: {
    [clearModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    [initPledgeAction]({ commit }, payload) {
      const { pledge, index } = payload;
      let j = 0;
      if ('owners' in pledge && pledge.owners.length > 0) {
        j = 0;
        pledge.owners.forEach((owner) => {
        //  commit(ADD_DUMMY_ENTITY, { pledge, entity: 'owner' });
          commit(UPDATE_ENTITY, { index: j, pledge, entityName: 'owner', entity: owner });
          commit(UPDATE_LOADING_OWNER, { pledge, index: j, value: '' });
          j += 1;
        });
      } else {
        commit(ADD_DUMMY_ENTITY, { pledge, entity: 'owner' });
        commit(UPDATE_LOADING_OWNER, { pledge, index: 0, value: '' });
      }
      if ('burdens' in pledge && pledge.burdens.length > 0) {
        j = 0;
        pledge.burdens.forEach((burden) => {
        //  commit(ADD_DUMMY_ENTITY, { pledge, entity: 'burden' });
          commit(UPDATE_ENTITY, { index: j, pledge, entityName: 'burden', entity: burden });
          commit(UPDATE_LOADING_BURDEN, { pledge, index: j, value: '' });
          j += 1;
        });
      } else {
        commit(ADD_DUMMY_ENTITY, { pledge, entity: 'burden' });
        commit(UPDATE_LOADING_BURDEN, { pledge, index: 0, value: '' });
      }
      if ('appraisals' in pledge && pledge.appraisals.length > 0) {
        j = 0;
        pledge.appraisals.forEach((appraisal) => {
          Service.getAppraiserByAppRaisal(appraisal.id)
            .then((res) => {
              if (res.data.included && res.data.included.length) {
                appraisal.appraiser = res.data.included[0].id;
                appraisal.appraiserName = res.data.included[0].title;
                appraisal.appraiserData = res.data.included[0];
              }
              commit(UPDATE_ENTITY, { index: j, pledge, entityName: 'appraisal', entity: appraisal });
              commit(UPDATE_LOADING_APPRAISAL, { pledge, index: j, value: '' });
              j += 1;
            });
        });
      } else {
        commit(ADD_DUMMY_ENTITY, { pledge, entity: 'appraisal' });
        commit(UPDATE_LOADING_APPRAISAL, { pledge, index: 0, value: '' });
      }
      if ('propertyMarket' in pledge) {
        commit(UPDATE_PROPERTY_MARKET, { pledge, propertyMarket: pledge.propertyMarket });
        commit(UPDATE_LOADING_PROPERTY_MARKET, { pledge, value: '' });
        let k = 0;
        if (pledge.propertyMarket.marketResearchs &&
          pledge.propertyMarket.marketResearchs.length > 0) {
          pledge.propertyMarket.marketResearchs.forEach((marketResearch) => {
            // commit(ADD_DUMMY_ENTITY, { pledge: pledge.propertyMarket, entity: 'marketResearch' });
            commit(UPDATE_ENTITY, {
              pledge: pledge.propertyMarket,
              entity: marketResearch,
              entityName: 'marketResearch',
              index: k,
            });
            if (Array.isArray(marketResearch.pdfs)) {
              let l = 0;
              marketResearch.pdfs.forEach((pdf) => {
              //  commit(ADD_DUMMY_ENTITY, { pledge: marketResearch, entity: 'pdf' });
                commit(UPDATE_ENTITY, { index: l, pledge: marketResearch, entity: pdf, entityName: 'pdf' });
                l += 1;
              });
            }
            k += 1;
          });
        } else {
          commit(ADD_DUMMY_ENTITY, { pledge: pledge.propertyMarket, entity: 'marketResearch' });
        }
      }
      commit(UPDATE_LOADING_PLEDGE, { index, value: '' });
      return commit(UPDATE_PLEDGE, { index, pledge });
    },
    [initModuleAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'init garantia');
      commit(CLEAR_MODULE);
      const { list, operation } = payload;
      commit(UPDATE_OPERATION, operation);
      const promises = [];
      list.forEach(pledge => promises.push(Service.getPledge(pledge)));

      if (promises.length === 0) {
        commit(ADD_DUMMY_PLEDGE);
        commit(UPDATE_LOADING_PLEDGE, { index: 0, value: '' });
        endLoading(dispatch, 'init garantia');
        return Promise.resolve();
      }
      return Promise.all(promises)
        .then((pledges) => {
          pledges.forEach((pledge, index) => {
          //  commit(ADD_DUMMY_PLEDGE);
            dispatch('initPledgeAction', { pledge, index });
          });
          endLoading(dispatch, 'init garantia');
        });
    },
    [searchAppraiserAction]({ commit, dispatch }, payload) {
      commit(UPDATE_SEARCHED_APPRAISER_NAME, []);
      commit(UPDATE_SEARCHING_APPRAISER_FLAG, true);
      return Service.searchAppraiser(payload)
        .then((lista) => {
          commit(UPDATE_SEARCHING_APPRAISER_FLAG, false);
          commit(UPDATE_SEARCHED_APPRAISER_NAME, lista);
        });
    },
    [updatePledgeAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'save pledge');
      const { index, pledge } = payload;
      let promise = null;
      if ('id' in pledge && pledge.id !== 'dummy') {
        promise = Service.updatePledge(pledge);
      } else if ('id' in pledge && pledge.id === 'dummy') {
        promise = Service.savePledge(pledge);
      } else {
        promise = Promise.reject('Incorrect pledge to save');
      }
      commit(UPDATE_LOADING_PLEDGE, { index, value: 'loading' });
      return promise
        .then(newPledge => commit(UPDATE_PLEDGE, { index, pledge: newPledge }))
        .then(() => commit(UPDATE_LOADING_PLEDGE, { index, value: '' }))
        .then(() => endLoading(dispatch, 'save pledge'));
    },
    [removePledgeAction]({ commit, state }, payload) {
      const { pledge } = payload;
      commit(UPDATE_LOADING_PLEDGE, { index: state.pledges.indexOf(pledge.id), value: 'removing' });
      if (pledge.id !== 'dummy') {
        return Service.removePledge(pledge)
          .then(() => commit(REMOVE_PLEDGE, payload))
          .then(() => commit(UPDATE_LOADING_PLEDGE, { index: state.loadingPledge[state.pledges.indexOf(pledge.id)] }));
      }
      commit(REMOVE_PLEDGE, payload);
      return commit(UPDATE_LOADING_PLEDGE, { index: state.loadingPledge[state.pledges.indexOf(pledge.id)] });
    },
    [addPledgeAction]({ commit }) {
      commit(ADD_DUMMY_PLEDGE);
    },
    [updateOwnerAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'update owner');
      const { index, pledge, owner } = payload;
      let promise = null;
      if ('id' in owner && owner.id !== 'dummy') {
        promise = Service.updateOwner(owner);
      } else if ('id' in owner && owner.id === 'dummy') {
        promise = Service.saveOwner(pledge, owner);
      } else {
        promise = Promise.reject('Incorrect owner to save');
      }
      commit(UPDATE_LOADING_OWNER, { pledge, index, value: 'loading' });
      return promise
        .then(newOwner => commit(UPDATE_ENTITY, { index, pledge, entity: newOwner, entityName: 'owner' }))
        .then(() => commit(UPDATE_LOADING_OWNER, { pledge, index, value: '' }))
        .then(() => endLoading(dispatch, 'update owner'));
    },
    [removeOwnerAction]({ commit, state }, payload) {
      const { pledge, owner } = payload;
      commit(UPDATE_LOADING_OWNER, { pledge, index: state.owners[pledge.id].indexOf(owner.id), value: 'removing' });
      if (owner && owner.id !== 'dummy') {
        return Service.removePledgeOwnerRelationship(pledge, owner)
          .then(() => {
            commit(REMOVE_ENTITY, { pledge, entity: owner, entityName: 'owner' });
            commit(UPDATE_LOADING_OWNER, { pledge, index: state.owners[pledge.id].indexOf(owner.id) });
            let found = false;
            Object.keys(state.owners).forEach((key) => {
              found = found || state.owners[key].indexOf(owner.id) > -1;
            });
            if (!found) {
              return Service.removeOwner(owner);
            }
            return Promise.resolve();
          });
      }
      commit(REMOVE_ENTITY, { pledge, entity: owner, entityName: 'owner' });
      return commit(UPDATE_LOADING_OWNER, { pledge, index: state.owners[pledge.id].indexOf(owner.id) });
    },
    [addOwnerAction]({ commit }, payload) {
      const { pledge } = payload;
      commit(ADD_DUMMY_ENTITY, { pledge, entity: 'owner' });
    },
    [updateBurdenAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'update burden');
      const { index, pledge, burden } = payload;
      let promise = null;
      if ('id' in burden && burden.id !== 'dummy') {
        promise = Service.updateBurden(burden);
      } else if ('id' in burden && burden.id === 'dummy') {
        promise = Service.saveBurden(pledge, burden);
      } else {
        promise = Promise.reject('Incorrect burden to save');
      }
      commit(UPDATE_LOADING_BURDEN, { pledge, index, value: 'loading' });
      return promise
        .then(newBurden => commit(UPDATE_ENTITY, { index, pledge, entity: newBurden, entityName: 'burden' }))
        .then(() => commit(UPDATE_LOADING_BURDEN, { pledge, index, value: '' }))
        .then(() => endLoading(dispatch, 'update burden'));
    },
    [removeBurdenAction]({ commit, state }, payload) {
      const { pledge, burden } = payload;
      commit(UPDATE_LOADING_BURDEN, { pledge, index: state.burdens[pledge.id].indexOf(burden.id), value: 'removing' });
      if (burden && burden.id !== 'dummy') {
        return Service.removePledgeBurdenRelationship(pledge, burden)
          .then(() => {
            commit(REMOVE_ENTITY, { pledge, entity: burden, entityName: 'burden' });
            commit(UPDATE_LOADING_BURDEN, { pledge, index: state.burdens[pledge.id].indexOf(burden.id) });
            let found = false;
            Object.keys(state.burdens).forEach((key) => {
              found = found || state.burdens[key].indexOf(burden.id) > -1;
            });
            if (!found) {
              return Service.removeBurden(burden);
            }
            return Promise.resolve();
          });
      }
      commit(REMOVE_ENTITY, { pledge, entity: burden, entityName: 'burden' });
      return commit(UPDATE_LOADING_BURDEN, { pledge, index: state.burdens[pledge.id].indexOf(burden.id) });
    },
    [addBurdenAction]({ commit }, payload) {
      const { pledge } = payload;
      commit(ADD_DUMMY_ENTITY, { pledge, entity: 'burden' });
    },
    [updateAppraisalAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'update appraisal');
      const { index, pledge, appraisal } = payload;
      let promise = null;
      if ('id' in appraisal && appraisal.id !== 'dummy') {
        promise = Service.updateAppraisal(appraisal);
      } else if ('id' in appraisal && appraisal.id === 'dummy') {
        promise = Service.saveAppraisal(pledge, appraisal);
      } else {
        promise = Promise.reject('Incorrect appraisal to save');
      }
      commit(UPDATE_LOADING_APPRAISAL, { pledge, index, value: 'loading' });
      return promise
        .then(newAppraisal => Service.getAppraiserByAppRaisal(newAppraisal.id)
          .then((res) => {
            if (res.data.included && res.data.included.length) {
              newAppraisal.appraiser = res.data.included[0].id;
              newAppraisal.appraiserName = res.data.included[0].title;
              newAppraisal.appraiserData = res.data.included[0];
            }
            commit(UPDATE_ENTITY, { index, pledge, entity: newAppraisal, entityName: 'appraisal' });
          }))
        .then(() => commit(UPDATE_LOADING_APPRAISAL, { pledge, index, value: '' }))
        .then(() => endLoading(dispatch, 'update appraisal'));
    },
    [removeAppraisalAction]({ commit, state }, payload) {
      const { pledge, appraisal } = payload;
      commit(UPDATE_LOADING_APPRAISAL, { pledge, index: state.appraisals[pledge.id].indexOf(appraisal.id), value: 'removing' });
      if (appraisal && appraisal.id !== 'dummy') {
        return Service.removePledgeAppraisalRelationship(pledge, appraisal)
          .then(() => {
            commit(UPDATE_LOADING_APPRAISAL, { pledge, index: state.appraisals[pledge.id].indexOf(appraisal.id) });
            commit(REMOVE_ENTITY, { pledge, entity: appraisal, entityName: 'appraisal' });
            let found = false;
            Object.keys(state.appraisals).forEach((key) => {
              found = found || state.appraisals[key].indexOf(appraisal.id) > -1;
            });
            if (!found) {
              return Service.removeAppraisal(appraisal);
            }
            return Promise.resolve();
          });
      }
      commit(REMOVE_ENTITY, { pledge, entity: appraisal, entityName: 'appraisal' });
      return commit(UPDATE_LOADING_APPRAISAL, { pledge, index: state.appraisals[pledge.id].indexOf(appraisal.id) });
    },
    [addAppraisalAction]({ commit }, payload) {
      const { pledge } = payload;
      commit(ADD_DUMMY_ENTITY, { pledge, entity: 'appraisal' });
    },
    [updateMarketResearchAction]({ commit, state, dispatch }, payload) {
      startLoading(dispatch, 'update market');
      const { index, propertyMarket, marketResearch } = payload;
      let promise = null;
      if ('id' in marketResearch && marketResearch.id !== 'dummy') {
        promise = Service.updateMarketResearch(marketResearch);
      } else if ('id' in marketResearch && marketResearch.id === 'dummy') {
        promise = Service.saveMarketResearch(propertyMarket, marketResearch);
      } else {
        promise = Promise.reject('Incorrect marketResearch to save');
      }
      commit(UPDATE_LOADING_MARKET_RESEARCH, { propertyMarket, index, value: 'loading' });
      return promise
        .then((newMarketResearch) => {
          commit(UPDATE_ENTITY, { index, pledge: propertyMarket, entity: newMarketResearch, entityName: 'marketResearch' });
          if (Array.isArray(newMarketResearch.pdfs)) {
            let i = 0;
            newMarketResearch.pdfs.forEach((pdf) => {
            /*  if (i <= state.pdfs[newMarketResearch.id].length) {
                commit(ADD_DUMMY_ENTITY, { pledge: newMarketResearch, entity: 'pdf' });
              } */
              commit(UPDATE_ENTITY, { index: i, pledge: newMarketResearch, entity: pdf, entityName: 'pdf' });
              i += 1;
            });
          }
        })
        .then(() => commit(UPDATE_LOADING_MARKET_RESEARCH, { propertyMarket, index, value: '' }))
        .then(() => endLoading(dispatch, 'update market'));
    },
    [removeMarketResearchAction]({ commit, state }, payload) {
      const { propertyMarket, marketResearch } = payload;
      commit(UPDATE_LOADING_MARKET_RESEARCH,
        { propertyMarket, index: state.marketResearchs[propertyMarket.id].indexOf(marketResearch.id), value: 'removing' });
      return Service.removePropertyMarketMarketResearchRelationship(propertyMarket, marketResearch)
        .then(() => {
          commit(UPDATE_LOADING_MARKET_RESEARCH,
            { propertyMarket, index: state.marketResearchs[propertyMarket.id].indexOf(marketResearch.id) });
          commit(REMOVE_ENTITY, { pledge: propertyMarket, entity: marketResearch, entityName: 'marketResearch' });
          let found = false;
          Object.keys(state.marketResearchs).forEach((key) => {
            found = found || state.marketResearchs[key].indexOf(marketResearch.id) > -1;
          });
          if (!found) {
            return Service.removeMarketResearch(marketResearch);
          }
          return Promise.resolve();
        });
    },
    [addMarketResearchAction]({ commit }, payload) {
      const { propertyMarket } = payload;
      commit(ADD_DUMMY_ENTITY, { pledge: propertyMarket, entity: 'marketResearch' });
    },
    [updatePropertyMarketAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'update property');
      const { pledge, propertyMarket } = payload;
      let promise = null;
      if ('id' in propertyMarket && propertyMarket.id !== 'dummy') {
        promise = Service.updatePropertyMarket(propertyMarket);
      } else if ('id' in propertyMarket && propertyMarket.id === 'dummy') {
        propertyMarket.title = `${pledge.title} Property Market`;
        promise = Service.savePropertyMarket(pledge, propertyMarket)
          .then((newPropertyMarket) => {
            commit(ADD_DUMMY_ENTITY, { pledge: newPropertyMarket, entity: 'marketResearch' });
            return newPropertyMarket;
          });
      } else {
        promise = Promise.reject('Incorrect propertyMarket to save');
      }
      commit(UPDATE_LOADING_PROPERTY_MARKET, { pledge, value: 'loading' });
      return promise
        .then(newPropertyMarket => commit(UPDATE_PROPERTY_MARKET, { pledge, propertyMarket: newPropertyMarket }))
        .then(() => commit(UPDATE_LOADING_PROPERTY_MARKET, { pledge, value: '' }))
        .then(() => endLoading(dispatch, 'update property'));
    },
    [removePropertyMarketAction]({ commit, state, dispatch }, payload) {
      const { propertyMarket, pledge } = payload;
      commit(UPDATE_LOADING_PROPERTY_MARKET, { pledge, value: 'removing' });
      return Service.removePledgePropertyMarketRelationship(pledge, propertyMarket)
        .then(() => propertyMarket.marketResearchs.map(marketResearch =>
          dispatch('removeMarketResearchAction', { marketResearch, propertyMarket })))
        .then(() => commit(RESET_PROPERTY_MARKET, { pledge }))
        .then(() => commit(UPDATE_LOADING_PROPERTY_MARKET, { pledge, value: '' }));
    },
    [updateOperationAction]({ dispatch, state, rootGetters }) {
      const pledges = [];
      state.pledges.forEach((c) => {
        if (c !== 'dummy') {
          pledges.push(c);
        }
      });
      const id = rootGetters.getOpid;
      const operation = {
        id,
        pledges,
      };
      return dispatch('operation-tab/saveOperationAction', operation, { root: true });
    },
    [replaceAppraiserAction]({ commit }) {
      commit(UPDATE_SEARCHING_APPRAISER_FLAG, false);
      commit(UPDATE_SEARCHED_APPRAISER_NAME, []);
    },
  },
  getters: {
    [pledgesGetter]: state => state.pledges.map(id => state.pledgesData[id]),
    [pledgeGetter]: state => id => state.pledgesData[id],
    [existDummyGetter]: state => state.pledges.indexOf('dummy') > -1,
    [searchingDireccionStateGetter]: state => id => state.searchingDireccion[id],
    [searchingPoblacionStateGetter]: state => id => state.searchingPoblacion[id],
    [pledgeOwnersGetter]: state => pledge => state.owners[pledge.id],
    [pledgeOwnersDataGetter]: state => pledge => state.owners[pledge.id].map(o => state.ownersData[o]),
    [getOwnerGetter]: state => owner => state.ownersData[owner],
    [canAddOwnerGetter]: state => pledge => state.owners[pledge.id].indexOf('dummy') < 0,
    [canRemoveOwnerGetter]: (state, getters) => payload =>
      payload.owner !== 'dummy' || getters[pledgeOwnersGetter](payload.pledge.id).length > 1,
    [loadingOwnerGetter]: state => (payload) => {
      if (payload.pledge.id in state.loadingOwner &&
        state.loadingOwner[payload.pledge.id][payload.owner]) {
        return state.loadingOwner[payload.pledge.id][payload.owner];
      }
      return '';
    },
    [pledgeBurdensGetter]: state => (pledge) => {
      if (pledge.id in state.burdens && state.burdens[pledge.id].length > 0) {
        return state.burdens[pledge.id];
      }
      return [];
    },
    [pledgeBurdensDataGetter]: state => pledge => state.burdens[pledge.id].map(b => state.burdensData[b]),
    [getBurdenGetter]: state => burden => state.burdensData[burden],
    [canAddBurdenGetter]: state => pledge => state.burdens[pledge.id].indexOf('dummy') < 0,
    [canRemoveBurdenGetter]: (state, getters) => payload =>
      payload.burden !== 'dummy' || getters[pledgeBurdensGetter](payload.pledge.id).length > 1,
    [loadingBurdenGetter]: state => (payload) => {
      if (payload.pledge.id in state.loadingBurden &&
        state.loadingBurden[payload.pledge.id][payload.burden]) {
        return state.loadingBurden[payload.pledge.id][payload.burden];
      }
      return '';
    },

    [pledgeAppraisalsGetter]: state => (pledge) => {
      if (pledge.id in state.appraisals && state.appraisals[pledge.id].length > 0) {
        return state.appraisals[pledge.id];
      }
      return [];
    },
    [pledgeAppraisalsDataGetter]: state => pledge => state.appraisals[pledge.id].map(a => state.appraisalsData[a]),
    [getAppraisalGetter]: state => appraisal => state.appraisalsData[appraisal],
    [canAddAppraisalGetter]: (state, getters) => pledge => getters[pledgeAppraisalsGetter](pledge.id).indexOf('dummy') > -1,
    [canRemoveAppraisalGetter]: (state, getters) => payload =>
      payload.appraisal !== 'dummy' || getters[pledgeAppraisalsGetter](payload.pledge.id).length > 1,
    [searchingAppraiserGetter]: state => (payload) => {
      if (payload.pledge.id in state.searchingAppraiser &&
        state.searchingAppraiser[payload.pledge.id][payload.index]) {
        return state.searchingAppraiser[payload.pledge.id][payload.index];
      }
      return '';
    },
    [searchedAppraisersGetter]: state => (payload) => {
      if (payload.pledge.id in state.searchedAppraisers &&
        state.searchedAppraisers[payload.pledge.id][payload.index]) {
        return state.searchedAppraisers[payload.pledge.id][payload.index];
      }
      return [];
    },
    [loadingAppraisalGetter]: state => (payload) => {
      if (payload.pledge.id in state.loadingAppraisal &&
        state.loadingAppraisal[payload.pledge.id][payload.appraisal]) {
        return state.loadingAppraisal[payload.pledge.id][payload.appraisal];
      }
      return '';
    },
    [propertyMarketResearchsGetter]: state => (propertyMarket) => {
      if (propertyMarket && propertyMarket.id in state.marketResearchs &&
        state.marketResearchs[propertyMarket.id]) {
        return state.marketResearchs[propertyMarket.id];
      }
      return [];
    },
    owners: state => state.owners,
    ownersData: state => state.ownersData,
    burdens: state => state.burdens,
    burdensData: state => state.burdensData,
    appraisals: state => state.appraisals,
    appraisalsData: state => state.appraisalsData,
    getMarketResearch: state => marketResearch => state.marketResearchsData[marketResearch],
    marketResearchs: state => state.marketResearchs,
    marketResearchsData: state => state.marketResearchsData,
    pdfs: state => state.pdfs,
    pdfsData: state => state.pdfsData,
    propertyMarketData: state => state.propertyMarketData,
    searchedAppraiserByName: state => state.searchedAppraiserByName,
    searchingAppraiserFlag: state => state.searchingAppraiserFlag,
    pledgesIds: state => state.pledges,
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-garantia/store.js